/*
 * @Author: Yun
 * @Date: 2024-02-19 15:24:33
 * @Last Modified by: Yun
 * @Last Modified time: 2024-03-05 10:09:57
 */
// https://api-gateway.cgtn.com/thumb?type=incr&id=

import React, { useState } from 'react'
import word1 from '@images/hotwords/word1.png'
import word2 from '@images/hotwords/word2.png'
import word3 from '@images/hotwords/word3.png'
import word4 from '@images/hotwords/word4.png'
import word5 from '@images/hotwords/word5.png'
import txt1 from '@images/hotwords/txt1.png'
import txt2 from '@images/hotwords/txt2.png'
import txt3 from '@images/hotwords/txt3.png'
import txt4 from '@images/hotwords/txt4.png'
import txt5 from '@images/hotwords/txt5.png'
import close from '@icons/close.jpg'
import $ from 'jquery'
import './index.less'

const PREFIX = 'hotwords-page'

const HotwordsPage = (props) => {
    const { id } = props

    const [active, setActive] = useState()

    const onWordClick = (e) => {
        $('body').css('overflow', 'hidden')
        setActive(e)
    }

    const onClose = () => {
        $('body').css('overflow', 'auto')
        setActive(false)
    }

    const handleTxt = () => {
        if (active) {
            switch (active) {
                case 'word1':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt1`} src={txt1} alt="" />
                case 'word2':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt2`} src={txt2} alt="" />
                case 'word3':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt3`} src={txt3} alt="" />
                case 'word4':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt4`} src={txt4} alt="" />
                case 'word5':
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt5`} src={txt5} alt="" />
                default:
                    return <img className={`${PREFIX}-txtImg ${PREFIX}-txt1`} src={txt1} alt="" />
            }
        }
    }

    return (
        <section className={PREFIX} id={id}>
            <div className={`${PREFIX}-wrapper`}>
                <div className={`${PREFIX}-words`}>
                    <img
                        className={`${PREFIX}-img ${PREFIX}-word1`}
                        src={word1}
                        alt=""
                        onClick={() => onWordClick('word1')}
                    />
                    <img
                        className={`${PREFIX}-img ${PREFIX}-word2`}
                        src={word2}
                        alt=""
                        onClick={() => onWordClick('word2')}
                    />
                    <img
                        className={`${PREFIX}-img ${PREFIX}-word3`}
                        src={word3}
                        alt=""
                        onClick={() => onWordClick('word3')}
                    />
                    <img
                        className={`${PREFIX}-img ${PREFIX}-word4`}
                        src={word4}
                        alt=""
                        onClick={() => onWordClick('word4')}
                    />
                    <img
                        className={`${PREFIX}-img ${PREFIX}-word5`}
                        src={word5}
                        alt=""
                        onClick={() => onWordClick('word5')}
                    />
                </div>
            </div>
            {active && (
                <div className={`${PREFIX}-txt`}>
                    <div className={`${PREFIX}-cover`}></div>
                    <img className={`${PREFIX}-close`} src={close} alt="" onClick={onClose} />
                    {handleTxt(active)}
                </div>
            )}
        </section>
    )
}

export default HotwordsPage
